// extracted by mini-css-extract-plugin
export default {"testimonial":"testimonials_testimonial__aFC0c","testimonialCard":"testimonials_testimonialCard__QSoIp","testimonialIcon":"testimonials_testimonialIcon__HZAlL"};